/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

/**
 * GP-specific pipe to format HTML to text.
 */
@Pipe({name: 'gpHtmlToText', pure: false})
export class HtmlToTextPipe implements PipeTransform {

  constructor() {
  }

  public transform(value: string): string {
    const div = document.createElement('DIV');
    div.innerHTML = value;

    return div.textContent;
  }
}
